export default __webpack_public_path__ + "static/media/message-white.a5367043.svg";